import {
  getLocationRanking,
  getLocationTypes,
  requestLocationsInference,
  RequestLocationsInferencePayload,
} from '@/api'
import { useTranslation } from 'react-i18next'
import { useMutation, useQuery } from 'react-query'

export const useLocationTypes = () => {
  const { i18n } = useTranslation()

  return useQuery('location-types', () => getLocationTypes(i18n.language), {
    staleTime: Infinity,
    cacheTime: Infinity,
  })
}

export const useLocationRanking = () =>
  useQuery('location-ranking', getLocationRanking, {
    staleTime: Infinity,
    cacheTime: Infinity,
  })

export const useRequestLocationsInference = () =>
  useMutation((payload: RequestLocationsInferencePayload) => {
    return requestLocationsInference(payload)
  })
